import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AttivaCard from "../../../components/card/AttivaCard";
import useHandleErrors from "../../../hooks/useHandleErrors";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import { InspectorCredentialsService } from "../../../services/product/inspectorCredentialsService";
import InspectorCredentialsForm from "../InspectorCredentialsForm";

const InspectorCredentialsCreate: FC = () => {

    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new InspectorCredentialsService();

    const [loading, setLoading] = useState<boolean>(false);

    const pageHeader = {
        title: "Nueva credencial inspector",
        breadcrumb: [
            { name: 'Productos', href: menuRoutes.products.path },
            { name: 'Credenciales inspector AF', href: menuRoutes.products.path + menuRoutes.products.inspectorCredentials },
            { name: "Crear" },
        ],
    };

    const handleSubmit = async (values: any) => {
        setLoading(true);
        try {
            const response = (await service.create({
                productId: values.productId,
                organisingCorporationId: values.organisingCorporationId,
                platformCif: values.platformCif || null,
                platformBusinessName: values.platformBusinessName || null,
                platformUrl: values.platformUrl || null,
                inspectorUser: values.inspectorUser || null,
                inspectorPassword: values.inspectorPassword || null,
            })).getResponseData();

            if (response.success) {
                navigate(menuRoutes.products.path + menuRoutes.products.inspectorCredentials);
                toast.success("Credencial creada correctamente");
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error("Error al crear la credencial");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title="Datos" className="mb-4">
                <InspectorCredentialsForm submit={handleSubmit} isLoading={loading} />
            </AttivaCard>
        </>
    );
}

export default InspectorCredentialsCreate;
